import {BaseGame} from '@fantasmagames/slot/src/system/BaseGame';
import {System} from '@fantasmagames/core/src/System';
import {GameSystem} from 'src/GameSystem';

export class Game extends BaseGame {
	protected createSystem(getUrlPath: Function, majorPerformanceCaveat: number): System {
		return new GameSystem(this.initViewport.bind(this), this.onReady.bind(this), getUrlPath, majorPerformanceCaveat);
	}

	protected init(): void {
		this._system.setupMobileApproach(false);
	}
}



// WEBPACK FOOTER //
// ./src/Game.ts